module.exports = __webpack_public_path__ + "img/credit-card.5b05d42d.svg";